import React from "react";
import { X } from "lucide-react";

function FilterChip({ label, onRemove }) {
  return (
    <span className="crm-filter-chip">
      {label}
      <button type="button" onClick={onRemove} aria-label={`Remove filter: ${label}`}>
        <X size={12} strokeWidth={2.4} />
      </button>
    </span>
  );
}

function ActiveFilterChips({ chips, onRemoveChip }) {
  if (!chips || chips.length === 0) return null;

  return (
    <div className="crm-filter-chips">
      {chips.map((chip) => (
        <FilterChip key={chip.type} label={chip.label} onRemove={() => onRemoveChip(chip)} />
      ))}
    </div>
  );
}

export default React.memo(ActiveFilterChips);
